import React, { useState, useEffect } from 'react';
import StaticTransition from './StaticTransition';
import StaticBackground from './StaticBackground';
import useReducedMotion from '../../hooks/useReducedMotion';

interface PageLayoutProps {
    children: React.ReactNode;
}

/**
 * Wraps every route. Owns the single static-transition overlay and the
 * single background grain — pages should not render their own.
 */
const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
    const reduceMotion = useReducedMotion();
    const [isVisible, setIsVisible] = useState(false);
    const [showTransition, setShowTransition] = useState(!reduceMotion);

    useEffect(() => {
        setIsVisible(true);

        if (reduceMotion) {
            setShowTransition(false);
            return;
        }

        // Was an uncleaned setTimeout, so navigating away inside the
        // first second still fired a state update on the unmounted layout.
        const timer = setTimeout(() => setShowTransition(false), 600);
        return () => clearTimeout(timer);
    }, [reduceMotion]);

    return (
        <>
            <StaticTransition
                isVisible={showTransition}
                duration={500}
            />
            <div className={`page-content ${isVisible ? 'visible' : ''}`}>
                <StaticBackground />
                {children}
            </div>
        </>
    );
};

export default PageLayout;
